module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), (!_vm.foodschosed.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-text text-center"
  }, [_vm._v("请选择所吃食物")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "name"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.foodschosed.length) ? _c('div', {
    staticClass: "foods-box"
  }, [_c('ul', {
    staticClass: "foods-wrap"
  }, _vm._l((_vm.foodschosed), function(foodselected, idx) {
    return _c('li', [(foodselected.foodThumb) ? _c('span', {
      staticClass: "food-icon",
      style: ({
        backgroundImage: 'url(' + foodselected.foodThumb + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "food-title ellipsis"
    }, [_vm._v(_vm._s(foodselected.foodTitle))]), _vm._v(" "), _c('div', {
      staticClass: "food-kilo"
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          _vm.delfood(idx)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_vm._v("查看食物血糖生成指数")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgfoods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/foods.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26beafd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/blood_sugar/selectfood.vue
// module id = 138
// module chunks = 1